import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserService } from "../../../shared/services/user.service";

import { DataService_iddesign } from "./shared/data.service";

import { wsClickOnceDeployInfo } from "./shared/wsClickOnceDeployInfo";

@Component({
	selector: "app-root",
	templateUrl: "./iddesign.component.html",
	styleUrls: ["./iddesign.component.css"],
})
export class IDDesignComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_iddesign, private userService: UserService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;

	//	Printers List
	public lstClickOnceDeploy: wsClickOnceDeployInfo[] = [];

	public CAASSPhotoIDDeployUrl: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.ClickOnceDeployURLSelect().subscribe((data) => this.ClickOnceDeployURLSelect_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ClickOnceDeployURLSelect_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ClickOnceDeployURLSelect_Complete(data: any) {
		this.lstClickOnceDeploy = data;

		if (this.lstClickOnceDeploy.length == 1) {
			this.CAASSPhotoIDDeployUrl = this.lstClickOnceDeploy[0].CAASSPhotoIDDeploy;
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSPhotoIDDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASSPhotoIDDeploy() {
		//Open link in same tab
		var a = document.createElement("a");
		a.href = this.CAASSPhotoIDDeployUrl;
		document.body.appendChild(a);
		a.click();
		a.remove();

		// window.open(this.CAASSPhotoIDDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
